<template>
  <div
    class="booking-add-ons__quantity-selector"
    :class="[{'--no-price': priceAndTypeLabel === ''}]"
  >
    <div class="booking-add-ons__quantity-selector-label">
      {{ title }}
      <v-dropdown
        v-if="showTooltip && tooltipMessage !== ''"
        class="tooltip tooltip-variant--add-on-footer"
        :distance="25"
        :skidding="0"
        placement="top"
      >
        <button
          class="tooltip-icon icon-info"
          :aria-label="tooltipMessage"
        />

        <template #popper>
          <div class="tooltip-variant--add-on-footer tooltip-content">
            <div class="tooltip-header">
              <button
                v-close-popper
                :aria-label="tc('booking.close')"
                tabindex="0"
                class="icon-close"
              />
            </div>
            <div class="tooltip-body">
              {{ tooltipMessage }}
            </div>
          </div>
        </template>
      </v-dropdown>
    </div>
    <div
      v-if="priceAndTypeLabel"
      class="booking-add-ons__quantity-selector-price"
    >
      {{ priceAndTypeLabel }}
    </div>
    <div class="booking-add-ons__quantity-selector-ctas">
      <button
        :class="['minus-cta', { '--disabled': disableMinusCta }]"
        :aria-disabled="disableMinusCta"
        :aria-label="decreaseQuantityLabel"
        @click="decreaseQuantity"
      >
        <div class="icon-minus" />
      </button>
      <span
        role="status"
        class="quantity"
      > <span class="sr-only">{{ title }}</span> {{ value }}</span>
      <button
        :class="['plus-cta', { '--disabled': disablePlusCta }]"
        :aria-disabled="disablePlusCta"
        :aria-label="increaseQuantityLabel"
        @click="increaseQuantity"
      >
        <div class="icon-add" />
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'BookingAddOnsQuantitySelector',
    props: {
      value: {
        type: Number,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      priceAndTypeLabel: {
        type: String,
        default: ''
      },
      maxQuantity: {
        type: Number,
        required: true
      },
      minQuantity: {
        type: Number,
        required: true
      },
      showTooltip: {
        type: Boolean,
        default: false
      },
      tooltipMessage: {
        type: String,
        default: ''
      },
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('auth', ['addOnsComponentData']),

      disableMinusCta() {
        return this.value === this.minQuantity
      },
      disablePlusCta() {
        return this.value === this.maxQuantity
      },

      decreaseQuantityLabel() {
        return this.addOnsComponentData.DecreaseQuantity.replace('{{quantityTitle}}', this.title)
      },
      increaseQuantityLabel() {
        return this.addOnsComponentData.IncreaseQuantity.replace('{{quantityTitle}}', this.title)
      },
    },
    methods: {
      decreaseQuantity() {
        if (this.value > this.minQuantity) {
          this.$emit('input', Number(this.value) - 1)
        }
      },
      increaseQuantity() {
        if (this.value < this.maxQuantity) {
          this.$emit('input', Number(this.value) + 1)
        }
      },
    }
  }
</script>
